// import styles from "./style.module.css"
import Header from '../header'
import Footer from '../footer'
import Banner from './Banner'
import Promobanner from './Promobanner'
import ChooseSim from './ChooseSim'
import Destinations from './Destinations'
import InstallationGuide from './InstallationGuide'
import StayConnected from './StayConnected/StayConnected'
import BlogSlider from './BlogSlider/BlogSlider'

function Globaltix() {

    return (
        <>
            <Header />
                <Banner />
                <Promobanner />
                <ChooseSim />
                <Destinations />
                <StayConnected />
                <InstallationGuide />
                <BlogSlider />
            <Footer />
        </>
    )
}

export default Globaltix